import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { FilterExtendedButton } from '../../types';
import type { Nullable } from '@shared/types/utils';

import STYLES from './SelectAllAndClearAll.module.scss';

const cls = cssModules(STYLES);

type Props = {
  selectAllButton?: Nullable<FilterExtendedButton>;
  clearAllButton?: Nullable<FilterExtendedButton>;
  title?: string;
};

const SelectAllAndClearAll = ({
  clearAllButton,
  selectAllButton,
  title,
}: Props) => {
  if (!selectAllButton || !clearAllButton) {
    return null;
  }

  return (
    <div className={cls('SelectAllAndClearAll__container')}>
      <BpkButtonV2
        onClick={selectAllButton.onClick}
        disabled={selectAllButton.disabled}
        type={BUTTON_TYPES.link}
        aria-label={`${selectAllButton.label} ${title}`}
      >
        <BpkText textStyle={TEXT_STYLES.label2}>
          {selectAllButton.label}
        </BpkText>
      </BpkButtonV2>
      <div className={cls('SelectAllAndClearAll__separator')} />
      <BpkButtonV2
        onClick={clearAllButton.onClick}
        disabled={clearAllButton.disabled}
        type={BUTTON_TYPES.link}
        aria-label={`${clearAllButton.label} ${title}`}
      >
        <BpkText textStyle={TEXT_STYLES.label2}>{clearAllButton.label}</BpkText>
      </BpkButtonV2>
    </div>
  );
};

export default SelectAllAndClearAll;
